/**
 * Centralized `board_id` values.
 *
 * Notes:
 * - Keep values in sync with App\Enums\BoardId (PHP) and BoardConfigs.json.
 * - Do not change existing values casually (treat as public API).
 */

export class BoardId {
    public static REVIEW = "review";
    public static TIKTOKS = "tiktoks";
    public static BEAUTY_NEWS = "beauty_news";
    public static EDITORIAL_REVIEWS = "editorial_reviews";
    public static EXPERT_REVIEWS = "expert_reviews";
    public static ACTIVITIES = "activities";
    public static TEST_MODAL = "test_modal";
    public static TEST_MODELESS = "test_modeless";
}
